var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhatsappIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    className: "st0",
    d: "M256.1,0h-0.1l0,0C114.8,0,0,114.8,0,256c0,56,18,107.9,48.7,150l-31.9,95.1l98.4-31.5 C155.7,496.5,204,512,256.1,512C397.2,512,512,397.2,512,256S397.2,0,256.1,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    className: "st1",
    d: "M405,361.5c-6.2,17.4-30.7,31.9-50.2,36.1c-13.4,2.8-30.8,5.1-89.7-19.3c-75.2-31.2-123.7-107.6-127.5-112.6 c-3.6-5-30.4-40.5-30.4-77.2s18.7-54.6,26.2-62.3c6.2-6.3,16.4-9.2,26.2-9.2c3.2,0,6,0.2,8.6,0.3c7.5,0.3,11.3,0.8,16.3,12.6 c6.2,14.9,21.2,51.6,23,55.4c1.8,3.8,3.6,8.9,1.1,13.9c-2.4,5.1-4.5,7.4-8.3,11.7s-7.4,7.7-11.1,12.4c-3.5,4.1-7.4,8.4-3,15.9 c4.4,7.4,19.4,31.9,41.5,51.6c28.6,25.4,51.7,33.6,60,37c6.2,2.6,13.5,2,18-2.8c5.7-6.2,12.8-16.4,20-26.5 c5.1-7.2,11.6-8.1,18.4-5.6c6.9,2.4,43.5,20.5,51,24.2c7.5,3.8,12.5,5.6,14.3,8.7C411.2,329.2,411.2,344,405,361.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsappIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp_icon.1f499a4d.svg";
export { ForwardRef as ReactComponent };